import { render, staticRenderFns } from "./calendarWCS.vue?vue&type=template&id=675c970c&scoped=true&"
import script from "./calendarWCS.vue?vue&type=script&lang=js&"
export * from "./calendarWCS.vue?vue&type=script&lang=js&"
import style0 from "./calendarWCS.vue?vue&type=style&index=0&id=675c970c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c970c",
  null
  
)

export default component.exports